/**
 * Employment & Labour Law hub — register with the global subcategory registry.
 */
import { EMPLOYMENT_LABOUR_LAW_SLUG, employmentLabourLawDefaultData } from "./employmentLabourLawData";
import { EmploymentLabourLawArticlesTab, EmploymentLabourLawMediaTab, EmploymentLabourLawOverviewTab } from "./EmploymentLabourLawDesign";

export const employmentLabourLawModule = {
  slug: EMPLOYMENT_LABOUR_LAW_SLUG,
  getDefaultData: () => employmentLabourLawDefaultData,
  Views: {
    overview: EmploymentLabourLawOverviewTab,
    articles: EmploymentLabourLawArticlesTab,
    media: EmploymentLabourLawMediaTab,
  },
};
